const devConfig = {
  // baseURL: "https://youth-backend-stage.braincuber.com/",
  baseURL: "https://api.youtheducation.co.in/",
  // baseURL: "http://192.168.29.50:5001/",
  // baseURL: "http://13.201.44.20:5000/",
  baseURL2: "https://api-notification.youtheducation.co.in/",
  // baseURL2: "http://52.66.185.174:5000/",
};
export const config = devConfig;
